import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';

@Pipe({
  name: 'contentAirport'
})
export class AirportPipe implements PipeTransform {

  constructor() {
  }

  transform(entry: Models.ContentEntry, parent = null): Models.AirportEntry {
    const airport: Models.AirportEntry = new Models.AirportEntry();
    if (!entry) {
      return null;
    }
    if (entry && entry.detail && entry.detail.Results && entry.detail.Results.Flight) {
      let flights = [];
      for (const item of entry.detail.Results.Flight) {
        const flight: any = new Models.FlightContent();
        flight.populateFromJSON({
          flightHistoryId: item.detail.FlightHistoryId,
          airlineName: item.detail.AirlineName,
          airlineCode: item.detail.AirlineCode,
          flight: item.detail.Flight,
          flightNumber: item.detail.FlightNumber,
          statusCode: item.detail.StatusCode,
          status: item.detail.Status,
          originCity: item.detail.OriginCity,
          originAirportCode: item.detail.OriginAirportCode || entry.detail.originAirportCode,
          scheduledTimestamp: item.detail.ScheduledTimeTimestamp,
          scheduledGateTime: item.detail.ScheduledGateTime,
          actualGateTime: item.detail.ActualGateTime,
          estimatedGateTime: item.detail.EstimatedGateTime,
          actualTime: item.detail.ActualTime,
          currentTime: item.detail.CurrentTime,
          currentGateTime: item.detail.CurrentGateTime,
          remarks: item.detail.Remarks,
          remarksWithTime: item.detail.RemarksWithTime,
          terminal: item.detail.Terminal,
          isCodeShare: item.detail.isCodeshare,
          operatedFlightNumber: item.detail.operatedFlightNumber,
          operatingAirlineName: item.detail.operatingAirlineName,
          operatingAirlineCode: item.detail.operatingAirlineCode,
          gate: item.detail.Gate
        });
        flight.destinationCity = item.detail.DestinationCity;
        flight.destinationAirportName = item.detail.DestinationAirportName;
        flight.destinationAirportCode = item.detail.DestinationAirportCode;
        flight.status = item.detail.Status;
        flight.airlineLogo = item.detail.AirlineLogo;
        flights.push(flight);
      }
      airport.title = entry.title;
      airport.flights = flights;
    }

    return airport;
  }
}
